module.exports = __webpack_public_path__ + "img/blog3.80d04636.jpg";